export default __webpack_public_path__ + "static/media/basket.66408bf4.svg";